const React = require('react');
const PropTypes = React.PropTypes;
const PureRenderMixin = require('react-addons-pure-render-mixin');
const warning = require('warning');

const PopoverBase = require('./popover-base.react');
const SpringsMixin = require('../mixins/springs');

/**
 * Variation of the popover that accepts text input.
 */
const InputPopover = React.createClass({

  propTypes: {
    value: PropTypes.string,
    onChange: PropTypes.func,
    valueLink: PropTypes.object,
    isOpen: PropTypes.bool.isRequired,
    onToggle: PropTypes.func.isRequired,
    target: PropTypes.element.isRequired,
    placeholder: PropTypes.string.isRequired,
    placement: PropTypes.string,
    isLoading: PropTypes.bool,
    actions: PropTypes.arrayOf(
      PropTypes.shape({
        key: PropTypes.string.isRequired,
        label: PropTypes.string.isRequired,
        handler: PropTypes.func.isRequired,
        modifiers: PropTypes.arrayOf(
          PropTypes.oneOf(['confirm', 'reject', 'primary'])
        ),
      })
    ).isRequired,
  },

  mixins: [
    PureRenderMixin,
    SpringsMixin(),
  ],

  getDefaultProps() {
    return {
      isOpen: false,
      placeholder: '',
      isLoading: false,
      modifiers: [],
      actions: [],
    };
  },

  componentWillMount() {
    // neither value or valueLink specified, and both aren't specified
    warning(
      this.props.value || this.props.valueLink,
      'InputPopover did not receive value or valueLink prop.'
    );
    warning(
      !(this.props.value && this.props.valueLink),
      'InputPopover received both value and valueLink prop.'
    );
  },

  render() {

    return (
      <PopoverBase isOpen={ this.props.isOpen } onToggle={ this.props.onToggle }
        target={ this.props.target } placement={ this.props.placement }
      >
        <div className="InputPopover-content">
          <textarea className="InputPopover-textarea"
            value={ this.props.value } valueLink={ this.props.valueLink }
            onChange={ this.props.onChange } autoFocus={ true }
            placeholder={ this.props.placeholder }
          />
          <PopoverBase.ActionBar actions={ this.props.actions } isLoading={ this.props.isLoading } />
        </div>
      </PopoverBase>
    );
  },

});

module.exports = InputPopover;
